import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ProductContextDirective } from 'ish-core/directives/product-context.directive';
import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { SkuQuantityType } from 'ish-core/models/product/product.model';
import { ProductItemDisplayType } from 'ish-shared/components/product/product-item/product-item.component';
import { SharedModule } from 'ish-shared/shared.module';

@Component({
  selector: 'ish-retail-set-parts',
  templateUrl: './retail-set-parts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, ProductContextDirective, AsyncPipe, TranslateModule],
})
export class RetailSetPartsComponent implements OnInit {
  readonly displayType = input<ProductItemDisplayType>('row');

  parts$: Observable<SkuQuantityType[]>;
  visible$: Observable<boolean>;

  private context = inject(ProductContextFacade);

  ngOnInit() {
    this.parts$ = this.context.select('parts');
    this.visible$ = this.context.select('displayProperties', 'retailSetParts');
  }
}
